import { ChevronDown, ChevronRight, AlertTriangle, Clock, Calendar, MinusCircle, Building2, User } from "lucide-react";
import { T } from "./todoTokens";

const ICONS = {
  overdue: AlertTriangle, due_today: Clock, this_week: Calendar, later: ChevronRight, no_date: MinusCircle,
};

/* Directive §8 — one white card per group. No overflow:hidden, or the row
   menus get clipped. */
export const TodoGroup = ({ g, collapsed, onToggle, children }) => {
  const Icon = ICONS[g.key] || (g.mode === "client" ? Building2 : User);
  return (
    <div className="rounded-[10px]" style={{ background: T.card, border: `1px solid ${T.cardEdge}` }}
      data-testid={`todo-group-${g.key}`}>
      <button onClick={onToggle} className="w-full flex items-center gap-2 text-left rounded-t-[10px]"
        style={{ background: T.groupHeader, padding: "11px 20px" }} data-testid={`todo-group-toggle-${g.key}`}>
        {collapsed ? <ChevronRight className="w-3.5 h-3.5" style={{ color: T.muted }} />
          : <ChevronDown className="w-3.5 h-3.5" style={{ color: T.muted }} />}
        <Icon className="w-3.5 h-3.5" style={{ color: g.tone || T.ink2 }} />
        <span className="text-[13.5px] font-bold" style={{ color: g.tone || T.ink }}>{g.label}</span>
        <span className="mono text-[11.5px] px-1.5 rounded" style={{ background: "#F1EEE6", color: T.ink2 }}
          data-testid={`todo-group-count-${g.key}`}>{g.openCount}</span>
        {g.sub && <span className="text-[12px]" style={{ color: T.muted }}>{g.sub}</span>}
        {g.key !== "overdue" && g.overdueCount > 0 && (
          <span className="text-[12px] font-semibold" style={{ color: T.overdue }}
            data-testid={`todo-group-overdue-${g.key}`}>{g.overdueCount} overdue</span>
        )}
      </button>
      {!collapsed && children}
    </div>
  );
};
